module.exports = __webpack_public_path__ + "img/gold-2.51c15099.png";